/**
 * Created by rastwe on 3/1/2017.
 */

import {applyMiddleware, createStore} from 'redux';
import {authenticationMiddleware, isOnlineMiddleware, workerMiddleware} from '@ey/voltron-core';

import Env from '../util/env';
import apiMiddleware from '../middlewares/api-middleware';
import ceapDownloadMiddleware from '../middlewares/ceap-download-middleware';
import ceapUserMiddleware from '../middlewares/ceap-user-middleware';
import {composeWithDevTools} from 'redux-devtools-extension/developmentOnly';
import config from '../auth/config';
import docHelperMiddleware from '../middlewares/docHelper-middleware';
import {hooks} from '../middlewares/upload-middleware-hooks';
import idbMiddleware from '../middlewares/idb-middleware';
import loginContextMiddleware from '../middlewares/loginContext-middleware';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import rootReducer from '../reducers';
import syncUpdate from '../middlewares/sync-update';
import {uploadMiddleware} from '@ey/voltron-doc-upload';
import versionCheck from '../middlewares/version-check';

import envConfig from '@ey/voltron-config';
import {adobeAnalytics} from '@ey/voltron-analytics';

/**
 * Configures and creates a Redux store that includes all reducers and
 * the initial state of the application.
 * The devToolsExtension reference in the compose() call is the Chrome
 * implementation of the Redux development tool. Refer to:
 * https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd?hl=en
 * Note that the reduxImmutableStateInvariant middleware is needed only
 * in dev mode to prevent developers from modifying the state directly.
 * Doing so will produce an error.
 * Thunk is here to use for async operations like Ajax.
 * @param {Object} initialState - The initial state of your application.
 *      Particularly useful for server side rendering.
 * @return {*} A Redux Store instance
 */
export default function configureStore(initialState) {
	const store = createStore(
		rootReducer,
		initialState,
		// Initiate redux dev tools
		composeWithDevTools(
			applyMiddleware(
				//offlineSync(config),
				isOnlineMiddleware(config),
				//offlineMonitor(config),
				ceapDownloadMiddleware(config),
				ceapUserMiddleware(config),
				loginContextMiddleware(config),
				adobeAnalytics.adobeAnalyticsMiddleware(envConfig.adobeAnalytics),
				authenticationMiddleware(config),
				apiMiddleware(config),
				uploadMiddleware(
					Env,
					{
						// These config options are used by the upchunk library: https://github.com/muxinc/upchunk
						chunkSize: 512, // KB
						retries: 3, // times
						delayBeforeRetry: 5, // seconds
						project: 'ares',
						defaultHookDocumentTypes: [98, 102]
					},
					hooks
				),
				docHelperMiddleware(config),
				//bookmark(config),
				workerMiddleware(config),
				/*unBookmark(config),*/
				idbMiddleware(config),
				//offlineHandlers(config),
				//offlineResponse(config),
				syncUpdate(config),
				versionCheck(config),
				// typeof window !== 'undefined' && reduxImmutableStateInvariant()
			)
		)
	);

	return store;
}
